import React from "react";
import { handleApiError } from "./apiErrorHandler";
import { type ApiClient, createApiClient } from "./fetchClient";

export function configureApi(apiUrl: string): ApiClient {
	console.info("using api endpoint", apiUrl);
	return createApiClient(apiUrl, {
		timeout: 120_000,
		defaultHeaders: {
			"x-portal-version": import.meta.env.VITE_VERSION ?? "DEV",
		},
		onError: handleApiError,
	});
}

export const APIContext = React.createContext<ApiClient>(createApiClient(""));
